export const ActionType = {
  SAVE_CATEGORIES: 'SAVE_CATEGORIES',
  SAVE_PAYMENTS: 'SAVE_PAYMENTS',
  SAVE_SUB_CATEGORIES: 'SAVE_SUB_CATEGORIES',
};

const system = (
  state = {
    categories: [],
    payments: [],
    subCategories: [],
  },
  { type, data },
) => {
  switch (type) {
    case ActionType.SAVE_CATEGORIES:
      return { ...state, categories: data };
    case ActionType.SAVE_PAYMENTS:
      return { ...state, payments: data };
    case ActionType.SAVE_SUB_CATEGORIES:
      return { ...state, subCategories: data };
    default:
      return state;
  }
};

export default system;
